<template>
  <div id="InputBar">
    <!--
    <div id="workbench">
      Workbench
      <div>{{placeholder_text}}</div>
      <div>
        recognition_on: {{recognition_on}} <br/>
        recog_disable: {{recognition_disabled}}<br/>
        recog_enabled: {{recognition_enabled}}<br/>
        Seconds countdown: {{seconds_countdown}}
        Autosend seconds: {{seconds_to_send}}
      </div>
    </div>
    -->
    <div id="mike_button" class="grid_item">
      <minimal-mike
        v-if="speech_recognition_works"
        :is_disabled="!allow_microphone"
        @microphone_input="microphone_input_data"
        @microphone_interim_data="microphone_input_interim_data"
      ></minimal-mike>
      <toggle-button
        v-if="speech_recognition_works"
        v-model="allow_microphone"
        :sync="true"
        :height=20
        :width=40
        :font-size=9
        :color="{checked: 'darkgreen',unchecked: 'darkblue', disabled: '#CCCCCC'}"
        :labels="{checked: 'on', unchecked: 'off'}"
      />
    </div>
    <div id="new_message_input" class="grid_item">
        <textarea
          ref="input_textarea"
          type="text"
          v-bind:placeholder="placeholder_text"
          v-on:keyup.enter="send_message"
          v-model="message_text"
          @click="stop_countdown"
          @focusin="stop_countdown"
        ></textarea>
    </div>
    <div id="send_controls" class="grid_item">
      <button
        id="send_message"
        @click="send_message"
        v-bind:disabled="!send_ok"
      >
        {{send_status}}
      </button>
      <span id="auto_control" v-if="recognition_enabled">
          <select v-model="seconds_to_send">
          <option value="off">Auto Send: Off</option>
          <option value="0">Immediate</option>
          <option value="1">1 second</option>
          <option value="2">2 seconds</option>
          <option value="3">3 seconds</option>
          <option value="4">4 seconds</option>

        </select>
        </span>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue'
    //import {vuex, mapState, mapActions} from 'vuex';
    import {mapState} from 'vuex';
    import minimalMike from "../components/minimalMike";
    //import SendIcon from "./SendIcon";
    import ToggleButton from 'vue-js-toggle-button';

    Vue.use(ToggleButton);

    export default {
        name: "InputBar",
        components: {
            minimalMike
        },
        data() {
            return {
                initial_placeholder_text: 'Type a message. ',
                placeholder_text: '',
                message_text: '',
                input_mode: 'text',  //text || audio
                listening: false,
                allow_microphone: false,
                seconds_to_send: "off",
                seconds_countdown: null,
                countdown_interval: null,
              speech_recognition_works: null


            }
        },
        mounted() {
          this.speech_recognition_works = (window.SpeechRecognition || window.webkitSpeechRecognition) ? true : false;
          this.placeholder_text = this.initial_placeholder_text;
          console.log(`INPUTBAR SEZ: got speech recognition?  ${this.speech_recognition_works}`)
        },
        computed: {
            recognition_enabled: function () {
                return !this.recognition_disabled
            },
            send_status: function () {
                let status = "Send";
                if (this.recognition_enabled) {
                    if (this.seconds_countdown > 0) {
                        status = `Send in ${this.seconds_countdown}`
                    } else {
                        status = "Send Now"
                    }
                }
                return status;
            },
            send_ok: function () {
                // If there's text to send, OK
                let ok = false;
                if (this.message_text.length) {
                    ok = true;
                }
                return ok
            },
            ...mapState(['listening_on', 'recognition_disabled', 'recognition_on', 'recognition_off'])

        },
        watch: {
            allow_microphone: function (val) {
                console.log(`Allow Microphone Updated to: ${val}`);
                const enable_speech = val;
                if (enable_speech) {
                    this.placeholder_text = 'Speech recognition on: Click the microphone and say something.';
                    this.message_text = '';
                    this.$store.dispatch('recognition_enabled');
                } else {
                    this.placeholder_text = this.initial_placeholder_text;
                    this.$store.dispatch('recognition_disabled');
                }
            }
        },

        methods: {
            async send_message(e) {
                console.log(`SEND: ${this.message_text}`);
                console.dir(e)
                //this.$emit('send-msg', this.message_text);
                this.$emit('update:messages', this.message_text);
                this.message_text = '';
            }
            ,
            microphone_input_interim_data(e) {
                console.log("INTERIM DATA:", e);
                this.message_text = '';
                this.placeholder_text = e;
                //this.$forceUpdate();
            }
            ,
            microphone_input_data(e) {
                console.log("FINAL RESULT, Edit or Send:", e);
                this.message_text = e.toString();
                this.placeholder_text = this.initial_placeholder_text;
                // wait for field update then:
                /*
                console.log("Set Focus to Text Area")
                this.$nextTick(
                    () => this.$refs['input_textarea'].focus()
                );

                 */
                if (this.recognition_enabled) {
                    this.autosend_start();
                }
            },
            mike_clicked(){
                alert("mike clicked");
                console.log('======================')
                console.log("Microphone clicked");
            },
            autosend_start(){
                this.seconds_countdown = parseInt(this.seconds_to_send);
                if (this.seconds_to_send > 0){
                    console.log(`Send after ${this.seconds_to_send} `);
                    this.countdown_interval = setInterval(()=>{
                        this.autosend();
                    },this.seconds_to_send*1000);
                } else {
                    this.autosend();
                }
            },
            autosend() {
              console.log(`Autosend called...`);
              this.seconds_countdown = this.seconds_countdown -1;
              if (this.seconds_countdown <= 0){
                  this.stop_countdown();
                  this.send_message();
              }

            },
            stop_countdown(){
                console.log("Countdown Stopped");
                this.seconds_countdown = 0;
                clearInterval(this.countdown_interval);
            },
            microphone_on() {
                console.log("Microphone is ON")
                this.message_text = '';
            }
            ,
            microphone_off() {
                console.log("Microphone is off")
            }
            ,
            toggle_speech_recog(e) {
                console.log("Got Toggle Speech")
                console.dir(e)

            }

        }
    }
</script>

<style scoped>
  .grid_item {
  }

  #InputBar {
    display: grid;
    grid-template-columns: auto 1fr auto;
    width: 100%;
    max-width: 900px;
    margin: auto;
    min-width: 300px;
    margin-bottom: 3px;
  }

  #mike_button {
    width: 5rem;
    height: 5rem;

  }

  #new_message_input {
    width: 100%;
    border: none;
  }

  textarea {
    margin: 6px;
    width: 100%;
    height: 90%;
    padding: 8px;
    font-size: 11pt;
    border: none;
    border-radius: 1rem;
    border: 1px solid black;
   outline: antiquewhite;
    resize: none;
  }

  textarea:focus {
/*    border: 3px solid navy; */
  }

  #workbench {
    width: 100%;
    display: grid;
    border-bottom: 10px solid darkred;
    grid-column-start: 1;
    grid-column-end: 4;
  }

  #send_message {
    width: 100px;
    padding: 3px;
    margin: 3px;
    border-radius: 5px;
    border: 2px solid navy;
    background-color: navy;
    color: antiquewhite;
    font-weight: bold;
    font-size: 12px;
  }

  #send_controls {
    padding: 10px;
    display: grid;
    grid-template-columns: 1fr;
    align-content: stretch;
    justify-content: stretch;
  }
</style>
